// Datos de contacto de GUIA, en un solo lugar.
// Antes el número de WhatsApp estaba copiado en cada pantalla, y dos de esas
// copias habían quedado con un placeholder (wa.me/5493516XXXXXX) que no
// llevaba a ningún lado. Por eso vive acá: cuando el número cambia —pasó el
// 22/09/2026, de un 3564 a este 351— se cambia en un solo lugar.
export const WHATSAPP = '5493512147749';
export const INSTAGRAM = 'somosguia.ai';

// Link de WhatsApp con el mensaje ya escrito.
export const waLink = (texto = '') =>
  `https://wa.me/${WHATSAPP}${texto ? `?text=${encodeURIComponent(texto)}` : ''}`;
